var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F250E1A6-A6BE-4590-9801-340A071ED2A6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-316.000000, -4878.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.75,4878 C338.716498,4878 339.5,4878.7835 339.5,4879.75 L339.5,4879.75 L339.5,4893.75 C339.5,4894.7165 338.716498,4895.5 337.75,4895.5 L337.75,4895.5 L317.75,4895.5 C316.783502,4895.5 316,4894.7165 316,4893.75 L316,4893.75 L316,4879.75 C316,4878.7835 316.783502,4878 317.75,4878 L317.75,4878 Z M319.37,4879.5 L317.75,4879.5 C317.611929,4879.5 317.5,4879.61193 317.5,4879.75 L317.5,4879.75 L317.5,4893.75 C317.5,4893.88807 317.611929,4894 317.75,4894 L317.75,4894 L319.37,4894 L319.37,4879.5 Z M323.12,4879.5 L321.13,4879.5 L321.13,4894 L323.12,4894 L323.12,4879.5 Z M326.87,4879.5 L324.88,4879.5 L324.88,4894 L326.87,4894 L326.87,4879.5 Z M330.62,4879.5 L328.63,4879.5 L328.63,4894 L330.62,4894 L330.62,4879.5 Z M334.37,4879.5 L332.38,4879.5 L332.38,4894 L334.37,4894 L334.37,4879.5 Z M337.75,4879.5 L336.13,4879.5 L336.13,4894 L337.75,4894 C337.868347,4894 337.967487,4893.91777 337.993397,4893.80732 L338,4893.75 L338,4879.75 C338,4879.61193 337.888071,4879.5 337.75,4879.5 L337.75,4879.5 Z",
    id: "Week"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWeek);
export default __webpack_public_path__ + "static/media/CalendarWeek.271089f971d68c314d52ca31a9af0689.svg";
export { ForwardRef as ReactComponent };